'use client';

import { useLocaleRuntime } from '@/hooks/i18n/useLocaleRuntime';

export const useI18n = () => {
    return useLocaleRuntime();
};
